export default class memberInfoModel {
    constructor(memberInfo) {
        if (memberInfo.addresses == null) {
            memberInfo.addresses = [];
        }
        this.addresses = structuredClone(memberInfo.addresses);
        this.birthday = memberInfo.birthday;
        this.email = memberInfo.email;
        this.gender = memberInfo.gender;
        this.invoice_carrier = memberInfo.invoice_carrier;
        this.is_line_member = memberInfo.is_line_member;
        this.mobile_phone = memberInfo.mobile_phone;
        this.name = memberInfo.name;
        this.npo_ban = memberInfo.npo_ban;
        this.phone = memberInfo.phone;
        this.s_phone = memberInfo.s_phone; // 店家自填電話
        this.s_vat_number = memberInfo.s_vat_number; // 店家自填統編
        this.vat_number = memberInfo.vat_number;
        this.vip_level = memberInfo.vip_level;
        this.store_comment = memberInfo.store_comment;
        this.store_member_uuid = memberInfo.store_member_uuid;
        this.total_points = memberInfo.total_points;
        this.total_reward_points = memberInfo.total_reward_points; // 總獎勵點數
    }
}